export default __webpack_public_path__ + "static/media/227.86abb039.png";